/* eslint-disable */
if (typeof __webpack_public_path_prefix__ === 'string') {
	__webpack_public_path__ = __webpack_public_path_prefix__ + __webpack_public_path__;
}
